import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ArrowLeft",
  "use": "icon-ArrowLeft-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-ArrowLeft\"><path d=\"M6.357 11.257l4.707-4.701L10.007 5.5 3.5 12l6.507 6.5 1.057-1.056-4.7-4.694 14.136-.004v-1.492l-14.143.003z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol